import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('MEDIA_COMMENT').plugin(axiosPlugin);

let fetchMediaCommentAction = redux.fetchActionGetOne();

let createMediaCommentAction = redux.fetchActionCreate();

let updateMediaCommentAction = redux.fetchActionUpdate();

let deleteMediaCommentAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchMediaComment = (mediaId, commentId, query = {}) => fetchMediaCommentAction(`/medias/${mediaId}/comments/${commentId}?${queryString.stringify(query)}`);
export const createMediaComment = (mediaId, data) => createMediaCommentAction(`/medias/${mediaId}/comments`, data);
export const updateMediaComment = (mediaId, commentId, data = {}) => updateMediaCommentAction(`/medias/${mediaId}/comments/${commentId}`, data);
export const deleteMediaComment = (mediaId, commentId = {}) => deleteMediaCommentAction(`/medias/${mediaId}/comments/${commentId}`);
export const resetMediaComment = () => redux.actions.reset();

export const mediaComment = redux.reducer();